
/* injects from baggage-loader */

export const APP_READY = "APP_READY";

export const PREFERENCES_SET = "PREFERENCES_SET";
export const PREFERENCES_RESET_ODDS = "PREFERENCES_RESET_ODDS";

export const SWARM_LOADING_START = "SWARM_LOADING_START";
export const SWARM_LOADING_DONE = "SWARM_LOADING_DONE";
export const SWARM_DATA_RECEIVED = "SWARM_DATA_RECEIVED";
export const SWARM_UPDATE_RECEIVED = "SWARM_UPDATE_RECEIVED";
export const SWARM_CLEAR_DATA = "SWARM_CLEAR_DATA";
export const SWARM_DELETE_NESTED_DATA = "SWARM_DELETE_NESTED_DATA";
export const SWARM_DATA_BET_HISTORY_UNSETTLED_UPDATE_RECEIVED = "SWARM_DATA_BET_HISTORY_UNSETTLED_UPDATE_RECEIVED";
export const DESTROY_LOADED_BET_HISTORY = "DESTROY_LOADED_BET_HISTORY";
export const CASINO_GAMES_OPENED = "CASINO_GAMES_OPENED";
export const SWARM_CONFIG_DATA = "SWARM_CONFIG_DATA";

export const DISCONNECTED = "DISCONNECTED";
export const CONNECTED = "CONNECTED";

export const SET_HORSE_RACING_DATA = "SET_HORSE_RACING_DATA";

export const LOGIN_START = "LOGIN_START";
export const LOGGED_IN = "LOGGED_IN"; // login state in UI
export const REALLY_LOGGED_IN = "REALLY_LOGGED_IN"; // the real login state
export const LOGGED_OUT = "LOGOUT";
export const LOGIN_FAILED = "LOGIN_FAILED";
export const IS_ADMIN_LOGGED_IN = "IS_ADMIN_LOGGED_IN";
export const IS_CARD_REGISTERED = "IS_CARD_REGISTERED";
export const CLEAR_CARD_REGISTERED = "CLEAR_CARD_REGISTERED";
export const SESSION_LOST = "SESSION_LOST";
export const SESSION_ACTIVE = "SESSION_ACTIVE";

export const USER_PROFILE_UPDATE_RECEIVED = "USER_PROFILE_UPDATE_RECEIVED";
export const UPDATE_USER_PROFILE = "UPDATE_USER_PROFILE";
export const FINISH_REGISTRATION = "FINISH_REGISTRATION";

//persistent UI
export const UI_EXPAND_ELEMENT = "UI_EXPAND_ELEMENT";
export const UI_COLLAPSE_ELEMENT = "UI_COLLAPSE_ELEMENT";

// non-persistent UI
export const UI_OPEN = "UI_OPEN";
export const SAVE_POPUP_TIMER = "SAVE_POPUP_TIMER";
export const UI_CLOSE = "UI_CLOSE";
export const TOGGLE_POPUP_TIMER = "TOGGLE_POPUP_TIMER";
export const UI_LOADING = "UI_LOADING";
export const UI_LOADING_DONE = "UI_LOADING_DONE";
export const UI_LOADING_FAILED = "UI_LOADING_FAILED";
export const UI_LOADING_RESET = "UI_LOADING_RESET";
export const UI_LAST_ROUTE_TYPE = "UI_LAST_ROUTE_TYPE";
export const UI_PREVIOUS_PATH = "UI_PREVIOUS_PATH";
export const UI_CURRENT_ROUTE_TYPE = "UI_CURRENT_ROUTE_TYPE";
export const SCROLL_TO_SPORT_ALIAS = "SCROLL_TO_SPORT_ALIAS";
export const SCROLLED_TO_SPORT_ALIAS = "SCROLLED_TO_SPORT_ALIAS";
export const UI_TOGGLE_ONE_GAME_ALL_MARKETS = "UI_TOGGLE_ONE_GAME_ALL_MARKETS";
export const CLOSE_GAME_COMPONENT = 'CLOSE_GAME_COMPONENT';
export const TICKET_SCAN = "TICKET_SCAN";
export const CHANGE_ODDS_FORMAT = "CHANGE_ODDS_FORMAT";
export const CHECK_CASHOUT_TICKET = "CHECK_CASHOUT_TICKET";
export const CHECKED_TICKETS = "CHECKED_TICKETS";
export const EARLY_CASHOUT = "EARLY_CASHOUT";
export const DATA_FINISHED = "DATA_FINISHED";
export const SPORT_GAMES_COUNT = "SPORT_GAMES_COUNT";
export const MOVE_GAME_STEP = "MOVE_GAME_STEP";
export const TOGGLE_REGION_CLASS = "TOGGLE_REGION_CLASS";
export const VIRTUALS_VIDEO_STREAM = "VIRTUALS_VIDEO_STREAM";

export const OPEN_POPUP = "OPEN_POPUP";
export const CLOSE_POPUP = "CLOSE_POPUP";

export const OPEN_IDLE_POPUP = "OPEN_IDLE_POPUP";
export const CLOSE_IDLE_POPUP = "CLOSE_IDLE_POPUP";

export const CONFIRMATION_DIALOG_ANSWER = "CONFIRMATION_DIALOG_ANSWER";

export const FAVORITE_ADD = "FAVORITE_ADD";
export const FAVORITE_REMOVE = "FAVORITE_REMOVE";
export const FAVORITES_CLEAR = "FAVORITES_CLEAR";
export const GAMES_FAVORITES_CLEAR = "GAMES_FAVORITES_CLEAR";
export const COMPETITIONS_FAVORITES_CLEAR = "COMPETITIONS_FAVORITES_CLEAR";
export const CASINO_FAVORITES_CLEAR = "CASINO_FAVORITES_CLEAR";
export const MARKET_FAVORITES_CLEAR = "MARKET_FAVORITES_CLEAR";
export const MAKE_QUICK_BET = "MAKE_QUICK_BET";
export const BETSLIP_TOGGLE_EVENT = "BETSLIP_TOGGLE_EVENT";
export const LOYAL_CARD = "LOYAL_CARD";
export const SET_LOYAL_CARD_INPUT_ACTIVE = "SET_LOYAL_CARD_INPUT_ACTIVE";
export const BETSLIP_ADD_COMPARE_EVENT = "BETSLIP_ADD_COMPARE_EVENT";
export const SWORM_DATA_BETSLIP_ADD_EVENT = 'SWORM_DATA_BETSLIP_ADD_EVENT';
export const BETSLIP_TOGGLE_HORSE_EVENT = "BETSLIP_TOGGLE_HORSE_EVENT";
export const CHANGE_HORSE_EVENT_TYPE = 'CHANGE_HORSE_EVENT_TYPE';
export const CHANGE_TYPE_TO_FORECAST_OR_TRICAST = 'CHANGE_TYPE_TO_FORECAST_OR_TRICAST';
export const BETSLIP_ADD = "BETSLIP_ADD";
export const BETSLIP_ADDS = "BETSLIP_ADDS";
export const BETSLIP_REMOVE = "BETSLIP_REMOVE";
export const BETSLIP_CLEAR = "BETSLIP_CLEAR";
export const BETSLIP_SET_TYPE = "BETSLIP_SET_TYPE";
export const BETSLIP_ACCEPT_CHANGES = "BETSLIP_ACCEPT_CHANGES";
export const BETSLIP_COPY = "BETSLIP_COPY";
export const BETSLIP_TOGGLE_QUICKBET = "BETSLIP_TOGGLE_QUICKBET";
export const BETSLIP_TOGGLE_BOOKINGBET = "BETSLIP_TOGGLE_BOOKINGBET";
export const BETSLIP_TOGGLE_SUPERBET = "BETSLIP_TOGGLE_SUPERBET";
export const BETSLIP_TOGGLE_FREEBET = "BETSLIP_TOGGLE_FREEBET";
export const BETSLIP_BET_ACCEPTED = "BETSLIP_BET_ACCEPTED";
export const BETSLIP_REPEAT_BET = "BETSLIP_REPEAT_BET";
export const BETSLIP_CLEAR_LAST_BET = "BETSLIP_CLEAR_LAST_BET";
export const BETSLIP_BET_FAILED = "BETSLIP_BET_FAILED";
export const BETSLIP_BET_PROCESSING = "BETSLIP_BET_PROCESSING";
export const BETSLIP_RESET_STATUS = "BETSLIP_RESET_STATUS";
export const SET_BET_EVENT_COUNTER_OFFER_ODD = "SET_BET_EVENT_COUNTER_OFFER_ODD";
export const BETSLIP_SET_STAKE = "BETSLIP_SET_STAKE";
export const SET_UK_BETSLIP_OPTION_STAKE = "SET_UK_BETSLIP_OPTION_STAKE";
export const UNSET_UK_BETSLIP_OPTION = "UNSET_UK_BETSLIP_OPTION";
export const UNSET_UK_BETSLIP_OPTION_STAKE = "UNSET_UK_BETSLIP_OPTION_STAKE";
export const UPDATE_BETSLIP_EVENTS = "UPDATE_BETSLIP_EVENTS";
export const TOGGLE_UK_BETSLIP_MULTIPLE_OPTIONS = "TOGGLE_UK_BETSLIP_MULTIPLE_OPTIONS";
export const BETSLIP_SET_UNIT_STAKE = "BETSLIP_SET_UNIT_STAKE";
export const BETSLIP_SET_ALL_EVENTS_STAKE = "BETSLIP_SET_ALL_EVENTS_STAKE";
export const BETSLIP_SET_EACH_WAY_MODE = "BETSLIP_SET_EACH_WAY_MODE";
export const UPDATE_EVENT_FROM_BET_ERROR = 'UPDATE_EVENT_FROM_BET_ERROR';
export const BETSLIP_SET_SYSTEM_OPT = "BETSLIP_SET_SYSTEM_OPT";
export const BETSLIP_SET_ACCEPT_OPT = "BETSLIP_SET_ACCEPT_OPT";
export const BETSLIP_TOGGLE_FREEBET_LOADING_STATE = "BETSLIP_TOGGLE_FREEBET_LOADING_STATE";
export const BETSLIP_TOGGLE_COUNTER_OFFER = "BETSLIP_TOGGLE_COUNTER_OFFER";
export const BETSLIP_SET_INCLUDE_IN_SYSTEM_CALC = "BETSLIP_SET_INCLUDE_IN_SYSTEM_CALC";
export const BETSLIP_QUICK_BET_NOTIFY = "BETSLIP_QUICK_BET_NOTIFY";
export const BETSLIP_QUICK_BET_NOTIFY_DISMISS = "BETSLIP_QUICK_BET_NOTIFY_DISMISS";
export const BETSLIP_SET_FREE_BETS = "BETSLIP_SET_FREE_BETS";
export const BETSLIP_SELECT_FREE_BET = "BETSLIP_SELECT_FREE_BET";
export const BETSLIP_UNSELECT_FREE_BET = "BETSLIP_UNSELECT_FREE_BET";
export const BETSLIP_SET_ACTIVE_EVENT = "BETSLIP_SET_ACTIVE_EVENT";
export const BETSLIP_SET_SYSTEM_ACTIVE_INPUT = "BETSLIP_SET_SYSTEM_ACTIVE_INPUT";
export const BETSLIP_SET_OFFERED_PRICE = "BETSLIP_SET_OFFERED_PRICE";

export const CMS_DATA_RECEIVED = "CMS_DATA_RECEIVED";

// registration captcha
export const CAPTCH_LOAD_SUCCESS = "CAPTCH_LOAD_SUCCESS";
export const CAPTCH_LOAD_FAILURE = "CAPTCH_LOAD_FAILURE";
export const UPDATE_MESSAGES_UNREAD_COUNT = "UPDATE_MESSAGES_UNREAD_COUNT";

export const REGISTER_MODE = "REGISTER_MODE";
export const SET_DEPOSIT_MODE = "SET_DEPOSIT_MODE";

/*
 * bet history filters
 */

export const SET_BET_HISTORY_FILTERS = "SET_BET_HISTORY_FILTERS";
export const RESET_BET_HISTORY_FILTERS = "RESET_BET_HISTORY_FILTERS";
export const SET_CASH_OUT_VALUE = "SET_CASH_OUT_VALUE";

/*
 * hash params
 * */

export const STORE_HASH_PARAMS = "STORE_HASH_PARAMS";
export const RESET_HASH_PARAMS = "RESET_HASH_PARAMS";
export const UPDATE_HASH_PARAMS = "UPDATE_HASH_PARAMS";

/*
 * virtual keyboard
 * */

export const TOGGLE_VIRTUAL_KEYBOARD = "TOGGLE_VIRTUAL_KEYBOARD";

//generic postfixes

export const START_POSTFIX = "_START";
export const DONE_POSTFIX = "_DONE";
export const FAIL_POSTFIX = "_FAIL";

// Terminal actions
export const SET_TERMINAL_ID = "SET_TERMINAL_ID";
export const GET_BOOSTED_ODDS = "GET_BOOSTED_ODDS";
export const SET_DATA_FOR_GAMES = "SET_DATA_FOR_GAMES";
export const SET_TERMINAL_ACUMULATOR_BONUSE = "SET_TERMINAL_ACUMULATOR_BONUSE";
export const SHOW_CASINO_FAVORITES = "SHOW_CASINO_FAVORITES";
export const SET_PARTNER_ID = "SET_PARTNER_ID";
export const UPDATE_TERMINAL_TOKEN = "UPDATE_TERMINAL_TOKEN";
export const SHOW_BALANCE = "SHOW_BALANCE";
export const ADD_TO_BALANCE = "ADD_TO_BALANCE";
export const ADD_PAGING_PROMOTED_GAMES = "ADD_PAGING";
export const SETUP_TERMINAL_DATA = "SETUP_TERMINAL_DATA";
export const TITO_ACCEPT_BET = "TITO_ACCEPT_BET";
export const TITO_CASHOUT_BET = "TITO_CASHOUT_BET";
export const SET_FEATURED_GAME = 'SET_FEATURED_GAME';
export const SET_TODAY_FIRST_ENTRY = 'SET_TODAY_FIRST_ENTRY';
export const PRINT_TICKET = "PRINT_TICKET";
export const PRINT_BET_BUILDER_TICKET = "PRINT_BET_BUILDER_TICKET";
export const PRINT_LOTTERY_TICKET = "PRINT_LOTTERY_TICKET";
export const PRINT_CLIENT_TICKET = "PRINT_CLIENT_TICKET";
export const SHOW_LAST_BETS_LIST = "SHOW_LAST_BETS_LIST";
export const CLEAR_LAST_BETS_LIST = "CLEAR_LAST_BETS_LIST";
export const TITO_ACCEPT_CASHOUT = "TITO_ACCEPT_CASHOUT";
export const TICKET_IN = "TICKET_IN";
export const PAY_CASINO_LOTTERY_WIN_TICKET = "PAY_CASINO_LOTTERY_WIN_TICKET";
export const GET_LAST_TICKET_BY_ID = "GET_LAST_TICKET_BY_ID";
export const GET_SUPERBET_TICKET_BY_ID = "GET_SUPERBET_TICKET_BY_ID";
export const SET_SUPERBET_ID = "SET_SUPERBET_ID";
export const REJECT_SUPERBET = "REJECT_SUPERBET";
export const SUPERBET_IN_PROCESS = "SUPERBET_IN_PROCESS";
export const GET_LAST_PAYED_TICKETS = "GET_LAST_PAYED_TICKETS";
export const PRINT_LAST_PAYED_TICKETS = "PRINT_LAST_PAYED_TICKETS";
export const CASHOUT_MONEY = "CASHOUT_MONEY";
export const CASHOUT_MONEY_CASH = "CASHOUT_MONEY_CASH";
export const CASHOUT_MONEY_WITH_FEE = "CASHOUT_MONEY_WITH_FEE";
export const CASHOUT_CLIENT_MONEY = "CASHOUT_CLIENT_MONEY";
export const PRINT_BOOKING_TICKET = "PRINT_BOOKING_TICKET";
export const TERMINAL_ERROR = "TERMINAL_ERROR";
export const SEND_LOGS = "SEND_LOGS";
export const LOCK_TERMINAL = "LOCK_TERMINAL";
export const UNLOCK_TERMINAL = "UNLOCK_TERMINAL";
export const HIDE_TERMINAL_ERROR = "HIDE_TERMINAL_ERROR";
export const SET_POPUP_LAUNCHER = "SET_POPUP_LAUNCHER";
export const SHUT_DOWN = "SHUT_DOWN";
export const PRINT_LAST_TICKET = "PRINT_LAST_TICKET";
export const PRINT_LAST_CASH_OUT_TICKET = "PRINT_LAST_CASH_OUT_TICKET";
export const REMOVE_STACKER_BALANCE = "REMOVE_STACKER_BALANCE";
export const SHOW_STACKER_BALANCE = "SHOW_STACKER_BALANCE";
export const STACKER_COLLECTION = "STACKER_COLLECTION";
export const REBOOT_PC = "REBOOT_PC";
export const NOTE_RECYCLER = "NOTE_RECYCLER";
export const OPEN_LAST_LOG_FILE = "OPEN_LAST_LOG_FILE";
export const LAST_ENTERED_BILL_AND_COINS = "LAST_ENTERED_BILL_AND_COINS";
export const RESET_BILL_ACCEPTOR = "RESET_BILL_ACCEPTOR";
export const RESET_DEVICE_CONNECTION = "RESET_DEVICE_CONNECTION";
export const CHECK_HOPPERS_ERRORS_AND_STATES = "CHECK_HOPPERS_ERRORS_AND_STATES";
export const SHOW_DEVICE_STATUS = "SHOW_DEVICE_STATUS";
export const CLOSE_APP_LOCATION = "CLOSE_APP_LOCATION";
export const UPPER_SCREEN = "UPPER_SCREEN";
export const TODAYS_REPORT = "TODAYS_REPORT";
export const MULTIPLEDAYS_REPORT ="MULTIPLEDAYS_REPORT";
export const GET_LAST_TICKETS = "GET_LAST_TICKETS";
export const SET_LANGUAGE = "SET_LANGUAGE";
export const LOGIN_ADMIN = "LOGIN_ADMIN";
export const SET_BALANCE = "SET_BALANCE";
export const SET_HOPPER_1_VALUE = "SET_HOPPER_1_VALUE";
export const SET_HOPPER_2_VALUE = "SET_HOPPER_2_VALUE";
export const ADMIN_PAGE_EXIT = "ADMIN_PAGE_EXIT";
export const SET_PROFILE_ERROR = "SET_PROFILE_ERROR";
export const RESET_UI_BY_IDLE_TIMER = "RESET_UI_BY_IDLE_TIMER";
export const SET_CURRENCY = "SET_CURRENCY";
export const LOCK_TERMINAL_ADMIN = "LOCK_TERMINAL_ADMIN";
export const UNLOCK_TERMINAL_ADMIN = "UNLOCK_TERMINAL_ADMIN";
export const SHOW_KEYBOARD = "SHOW_KEYBOARD";
export const CHANGE_SPORTSBOOK_LAYOUT = "CHANGE_SPORTSBOOK_LAYOUT";
export const SET_TERMINAL_AUTH_DATA = "SET_TERMINAL_AUTH_DATA";
export const SET_STARTUP_SETTINGS = "SET_STARTUP_SETTINGS";
export const SET_TERMINAL_BALANCE = "SET_TERMINAL_BALANCE";
export const GAME_MARKETS_LIST_UPDATE_RECEIVED = "GAME_MARKETS_LIST_UPDATE_RECEIVED";
export const RESET_GAME_MARKETS_LIST = "RESET_GAME_MARKETS_LIST";
export const STANDART_GAMES_LIST_UPDATE_RECEIVED = "STANDART_GAMES_LIST_UPDATE_RECEIVED";
export const RESET_STANDART_GAMES_LIST = "RESET_STANDART_GAMES_LIST";
export const MATCH_OF_THE_DAY_GAMES_LIST_UPDATE_RECEIVED = "MATCH_OF_THE_DAY_GAMES_LIST_UPDATE_RECEIVED";
export const RESET_MATCH_OF_THE_DAY_GAMES_LIST = "RESET_MATCH_OF_THE_DAY_GAMES_LIST";
export const SET_TAX = "SET_TAX";
export const USER_DID_LOGIN = "USER_DID_LOGIN";
export const USER_DID_LOGOUT = "USER_DID_LOGOUT";
export const MOUSE_MOVE_POSITION = "MOUSE_MOVE_POSITION";
export const SET_DEPOSIT_USER_DATA = "SET_DEPOSIT_USER_DATA";
export const SET_DEPOSIT_BALANCE = "SET_DEPOSIT_BALANCE";
export const REMOVE_DEPOSIT_BALANCE = "REMOVE_DEPOSIT_BALANCE";
export const DO_CONFIRM = "DO_CONFIRM";
export const CLEAR_USER_ID = "CLEAR_USER_ID";
export const FINISH_DEPOSIT = "FINISH_DEPOSIT";
export const HIDE_BETSLIP = "HIDE_BETSLIP";
export const CONFIRM_REGISTRATION_NEW_CARD = "CONFIRM_REGISTRATION_NEW_CARD";
export const UPDATE_PLAYER_CARD_ID = "UPDATE_PLAYER_CARD_ID";
export const DEPOSIT_TO_CLIENT_ACCOUNT = "DEPOSIT_TO_CLIENT_ACCOUNT"

export const ASIAN_GAMES_TOGGLE_DATE_SORT = "ASIAN_GAMES_TOGGLE_DATE_SORT";
export const ASIAN_GAMES_LIST_UPDATE_RECEIVED = "ASIAN_GAMES_LIST_UPDATE_RECEIVED";
export const RESET_ASIAN_GAMES_LIST = "RESET_ASIAN_GAMES_LIST";

export const ADMIN_USER_COMMANDS = 'ADMIN_USER_COMMANDS'
export const GET_ADMIN_USERS = 'GET_ADMIN_USERS'
export const DELETE_ADMIN_USER = 'DELETE_ADMIN_USER'
export const RFID_REGISTER_MODE = 'RFID_REGISTER_MODE'
export const SET_RESTRICTED_MODE = 'SET_RESTRICTED_MODE'
export const SET_DELETABLE_ADMIN = 'SET_DELETABLE_ADMIN'

export const DEPOSIT = "DEPOSIT";